import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutBottom: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-bottom, margin, padding"><path d="M20.25 3.75V16.25L3.75 16.25V3.75L20.25 3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M21 20.25H3" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconLayoutBottom;
